<template>
  <div :class="`z-dialog ${activeClass}`">
    <div class="mask" @click="onMask"></div>
    <div class="dialog-box">
      <div v-if="title" class="title">{{ title }}</div>
      <div v-if="content" class="content v-middle">
        <div class="v-middle-content">{{ content }}</div>
      </div>
      <div v-else class="content"><slot></slot></div>
      <div class="options">
        <button class="btn ok" @click="onOk">{{ okText }}</button>
        <button v-if="type !== 'alert'" class="btn" @click="onCancel">{{ cancelText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZDialog',
  props: {
    type: {
      type: String,
      default: 'alert'
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    }
  },
  data() {
    return {
      activeClass: ''
    }
  },
  methods: {
    onMask() {
      this.close()
      this.$emit('mask')
      this.$emit('close')
    },
    onCancel() {
      this.close()
      this.$emit('cancel')
      this.$emit('close')
    },
    onOk() {
      this.close()
      this.$emit('ok')
      this.$emit('close')
    },
    open() {
      this.activeClass = 'z-dialog-open'
    },
    close() {
      this.activeClass = ''
    }
  }
}
</script>

<style lang="postcss">
.z-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -100;
  opacity: 0;

  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .dialog-box {
    background-color: #fff;
    border-radius: 5px;
    position: absolute;
    width: 400px;
    top: 50%;
    left: 50%;
    margin: -100px -200px;
    word-break: break-word;
    overflow: hidden;
    padding: 25px;

    .title {
      font-size: 16px;
      color: #333;
      border-bottom: 1px solid #ddd;
      line-height: 34px;
    }

    .content {
      margin: 20px 0;
      font-size: 16px;
      height: 72px;
      text-align: center;
      color: #fabe00;
      font-weight: 700;
    }

    .v-middle {
      .v-middle-content {
        display: inline-block;
        vertical-align: middle;
      }

      &:after {
        content: '';
        width: 0;
        height: 100%;
        display: inline-block;
        vertical-align: middle;
      }
    }

    .options {
      text-align: center;
      padding-bottom: 10px;
    }

    .btn {
      border-radius: 5px;
      display: inline-block;
      position: relative;
      overflow: hidden;
      border: 1px solid #06f;
      color: #06f;
      font-size: 16px;
      padding: 0 10px;
      height: 38px;
      cursor: pointer;
      width: 120px;
      margin: 0 10px;
      background-color: #fff;

      &.ok {
        color: #fff;
        background-color: #06f;
      }
    }
  }

  &.z-dialog-open {
    z-index: 200;
    opacity: 1;

    .mask {
      opacity: 1;
    }
  }
}
</style>
